module.exports = __webpack_public_path__ + "img/mountain-range.ad2b689a.svg";